import type { CatalogDTO, CatalogInHeaders, ClientEntityMetaData } from '@psw/shared';
import { immerable } from 'immer';
import { stringifyToQueryUrl, UrlKeys } from '../Components/Utils/UrlUtil';

export class Catalog implements CatalogDTO {
  [immerable] = true;

  batch_analysis_additional_attributes_columns?: { label: string; key: string }[];
  client_entity_filters?: ClientEntityMetaData;
  currency: string;
  language: string;
  name: string;
  refresh_date: string;
  similarity_threshold: { [x: string]: number };
  taxonomies: string[];
  latest_price_update_date?: string;

  organization: string;

  /**
   * Taxonomy currently selected
   */
  taxonomy: string;

  constructor(data: CatalogDTO & { organization: string; taxonomy?: string }) {
    this.batch_analysis_additional_attributes_columns = data.batch_analysis_additional_attributes_columns;
    this.client_entity_filters = data.client_entity_filters;
    this.currency = data.currency;
    this.language = data.language;
    this.name = data.name;
    this.refresh_date = data.refresh_date;
    this.latest_price_update_date = data.latest_price_update_date;
    this.similarity_threshold = data.similarity_threshold;
    this.taxonomies = data.taxonomies;

    this.organization = data.organization;
    this.taxonomy = data.taxonomy || '';
  }

  buildUrlParams() {
    return stringifyToQueryUrl({
      [UrlKeys.Catalog]: this.name,
      [UrlKeys.Organization]: this.organization,
      [UrlKeys.Taxonomy]: this.taxonomy,
    });
  }

  /**
   * Build the object to be used in headers for API calls
   */
  toCatalogInHeaders(): CatalogInHeaders {
    return {
      catalog: this.name,
      currency: this.currency,
      language: this.language,
      organization: this.organization,
      taxonomy: this.taxonomy,
    };
  }

  get currencySymbol() {
    const fakeValue = 0;
    return fakeValue.toLocaleString('en', { style: 'currency', currency: this.currency }).replace('0.00', '');
  }
}
